<template>
  <div class="input-checkbox">
    <input
      :id="compId"
      :name="name"
      :value="inputValue"
      :checked="checked"
      :disabled="disabled"
      :class="{ disabled: disabled }"
      type="checkbox"
      @change="eventEmiter"
    />
    <label
      :for="compId"
      :class="{ disabled: disabled }"
      class="input-checkbox--fakebox"
    >
      <Icon :icon="checkedIcon" />
    </label>

    <label v-if="label" :for="compId" class="input-checkbox--label">
      <span
        :title="label"
        :class="{ disabled: disabled }"
        class="input-checkbox--label__overflow"
      >
        <slot
          name="inputCheckboxLabel"
          :inputValue="inputValue"
          :label="label"
          >{{ label }}</slot
        >
      </span>

      <InfoTooltip
        v-if="infoIcon"
        :text="infoText"
        :tooltipMinWidth="tooltipMinWidth"
        class="input-checkbox--info-tooltip"
    /></label>
  </div>
</template>

<script>
/**
 * * Componente de input do tipo checkbox
 */
import isEqual from 'lodash.isequal'
import InfoTooltip from '../patterns/InfoTooltip'
import { getRandomInt } from '@/helpers/math'

export default {
  name: 'InputCheckbox',
  components: {
    InfoTooltip
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    inputValue: [String, Number, Object],
    value: [Array, Boolean],
    name: String,
    label: String,
    checked: {
      type: Boolean,
      default: false
    },
    checkedIcon: {
      type: String,
      default: 'check'
    },
    /**
     * Se deve apresentar um ícone de informação sobre o campo
     */
    infoIcon: {
      type: Boolean,
      default: false
    },
    /**
     * Texto de informação
     */
    infoText: {
      type: String,
      default: 'Informação sobre o campo'
    },
    /** largura mínima da tooltip */
    tooltipMinWidth: {
      type: [Number, String],
      default: 150
    },
    disabled: Boolean
  },
  data() {
    return {
      defaultId: `input-checkbox-${getRandomInt(0, 99999)}`
    }
  },
  computed: {
    compId() {
      return this.id || this.defaultId
    }
  },
  methods: {
    eventEmiter(e) {
      if (this.inputValue && Array.isArray(this.value)) {
        this.multiChecksEventEmiter(e)
        return
      }

      const currentValue = e.target.checked

      this.$emit('input', currentValue)
      this.$emit('change', currentValue)
    },
    /**
     * Tratamento para quando existem mais de um checkbox usando o mesmo array do v-model
     */
    multiChecksEventEmiter(e) {
      let currentValue = [...this.value]

      if (e.target.checked) {
        currentValue.push(this.inputValue || e.target.checked)
      } else {
        currentValue = currentValue.filter((item) => {
          return !isEqual(item, this.inputValue)
        })
      }

      this.$emit('input', currentValue)
      this.$emit('change', currentValue)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-checkbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select: none;

  &--label {
    display: inline-flex;
    align-items: center;
    width: calc(100% - 23px);
    margin: 0 0 0 8px;
    cursor: pointer;
    font-size: font-size('size-medium');

    &__overflow {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  &--info-tooltip {
    margin-left: 7px;
  }

  &--fakebox {
    display: flex;
    margin: 0;
    justify-content: center;
    align-items: center;
    width: 14px;
    height: 14px;
    border: 1px solid $gray-dark;
    background-color: $white;
    cursor: pointer;

    .icon {
      width: 8px;
      color: $primary;
      display: none;
    }
  }

  input {
    display: none;

    &:checked ~ .input-checkbox--fakebox {
      background-color: $primary;

      .icon {
        width: 9px;
        color: $white;
        display: block;
      }
    }
  }

  .disabled {
    opacity: 0.4;
    filter: grayscale(1);
  }
}
</style>
